import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.3075 16.3025C12.191 15.6293 11.1538 14.8326 10.2155 13.9275C9.31176 12.9876 8.51521 11.9502 7.84051 10.8345C8.49953 10.1658 10.1984 8.21988 10.1984 8.21988L7.49907 2.09766C7.49907 2.09766 3.49607 3.13821 2.32432 3.44015C1.72056 6.40887 3.7353 12.6155 7.63051 16.5115C11.527 20.4088 17.9337 22.0613 20.7059 21.8203C21.2978 19.9587 22.048 16.643 22.048 16.643L15.9238 13.9424C15.9238 13.9424 13.9755 15.6435 13.3075 16.3025Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }